import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { PoolID } from '~src/settings/bridge-settings/sections/types/PoolID';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { EdgePoolError } from '../../sections/types/EdgePoolError';

export interface IDeleteEdgePoolsParams {
  poolIds: PoolID[];
  bridgeSettingsVersion: string;
  siteId: string;
}

export interface IDeleteEdgePoolsResult extends IResult {
  success?: {
    poolIds: PoolID[];
    siteID: string;
  };
  error?: EdgePoolError;
  bridgeSettingsVersion: string;
}

export class DeleteEdgePoolsRequest extends Request<IDeleteEdgePoolsParams, IDeleteEdgePoolsResult> {
  constructor(params: IDeleteEdgePoolsParams) {
    super('deleteEdgePools', params);
  }
}
